import React from 'react'
import { Col, Row } from 'react-bootstrap'

import CheckpointSelector from '../../checkpoint/CheckpointSelector'
import BizLocationSelector from '../../component/BizLocation/BizLocationSelector'
import BreadcrumbItem from '../../component/BreadcrumbItem/BreadcrumbItem'
import { DateRangeSelector } from '../../component/Date/DateRangeSelector'
import ProductTypeSelector from '../../productType/component/ProductTypeSelector'
import ReadpointSelector from '../../readpoint/component/ReadpointSelector'
import { dayMonthYearAtTimeWithSeconds, getEndDate, getLastWeek, getStartDate } from '../../utils/dates'

class TransactionsItemsGrid {

  title = "Itens das transações"

  customFilters = { dateBegin: getStartDate(getLastWeek()), dateEnd: getEndDate() }

  showNewButton = false
  exportNewPage=true
  showPdfButton = false

  customBreadcrumbs = [<BreadcrumbItem key={1} title="Itens das transações"/>]

  columns = [
    {
      Header: "EPC's",
      accessor: 'asset.tags.value',
      Cell: ({ original }) => {
        if (!(original.asset && original.asset.tags)) {
          return <p>Sem dados</p>
        }
        return original.asset.tags.map(x => (<p>{x.value}</p>))
      }
    },
    {
      Header: "Referência",
      accessor: 'asset.productType.reference'
    },
    {
      Header: "Nome",
      accessor: 'asset.productType.friendlyName',
      HeaderColumn: true
    },
    {
      Header: "Origem",
      accessor: 'out.bizLocation.friendlyName'
    },
    {
      Header: "Destino",
      accessor: 'lsd.bizLocation.friendlyName'
    },
    {
      Header: "Lote",
      accessor: 'asset.lot.code'
    },
    {
      Header: "Ponto de controle",
      accessor: "checkpoint.friendlyName"
    },
    {
      Header: "Ponto de leitura",
      accessor: 'readPoint.friendlyName'
    },
    {
      Header: "Data",
      accessor: 'readDate',
      isDate: true,
      Cell: ({ original }) => original.readDate && dayMonthYearAtTimeWithSeconds(original.readDate)
    },
  ]

  customFilterComponent = (_props, _state, onChange) => {
    const handleSetValue = (filterEntity) => {
      return (value) => {
        this.customFilters[filterEntity] = value
        onChange && onChange(this.customFilters)
      }
    }

    return (
      <Row>
        <Col md={4}>
          <ProductTypeSelector setValue={handleSetValue('productTypeId')} />
        </Col>
        <Col md={4}>
          <BizLocationSelector setValue={handleSetValue('bizLocationIdIn')} title="Local de entrada" />
        </Col>
        <Col md={4}>
          <BizLocationSelector setValue={handleSetValue('outBizLocationId')} title="Local de saída" />
        </Col>
        <Col md={4}>
          <CheckpointSelector setValue={handleSetValue('checkpointId')} />
        </Col>
        <Col md={4}>
          <ReadpointSelector setValue={handleSetValue('readPointId')} />
        </Col>
        <Col md={4}>
          <DateRangeSelector
            defaultEndDate={this.customFilters.dateEnd}
            defaultStartDate={this.customFilters.dateBegin}
            onChange={(startDate, endDate) => {
              this.customFilters.dateBegin = startDate
              this.customFilters.dateEnd = endDate
              onChange && onChange(this.customFilters)
            }}
          />
        </Col>
      </Row>
    )
  }

  endpoint = (_props, { customFilter }) => {
    const filterParams = new URLSearchParams({})

    customFilter.productTypeId && filterParams.append('productTypeId', this.customFilters.productTypeId)
    customFilter.bizLocationIdIn && filterParams.append('bizLocationIdIn', this.customFilters.bizLocationIdIn)
    customFilter.outBizLocationId && filterParams.append('outBizLocationId', this.customFilters.outBizLocationId)
    customFilter.checkpointId && filterParams.append('checkpointId', this.customFilters.checkpointId)
    customFilter.readPointId && filterParams.append('readpointId', this.customFilters.readPointId)
    customFilter.dateBegin && filterParams.append('dateBegin', this.customFilters.dateBegin.toISOString())
    customFilter.dateEnd && filterParams.append('dateEnd', this.customFilters.dateEnd.toISOString())

    return `ton/v1/transactions/items?status=SUCCESS&${filterParams.toString()}`
  }
}

export default TransactionsItemsGrid



// WEBPACK FOOTER //
// ./src/customGrid/entities/TransactionsItemsGrid.js